import PropTypes from 'prop-types';
import React from 'react';

import { AdminBrowseCategoriesPage } from 'app/components/admin/browse/categories';

export function AdminBrowseCategoriesPageRoute({ basePageRoute }) {
  return <AdminBrowseCategoriesPage basePageRoute={basePageRoute} />;
}

AdminBrowseCategoriesPageRoute.propTypes = {
  basePageRoute: PropTypes.string.isRequired
};

export default AdminBrowseCategoriesPageRoute;
